import { ColorString, GradientColorObject, Options, PatternObject, Point } from 'highcharts'
import { CSS } from '@stitches/react'

export type BasicSeriesData = {
  name: string
  data: Array<[number, number]>
  percentInTitle?: boolean
  color?: string
  fillColor?: ColorString | GradientColorObject | PatternObject | undefined
  sameYAxis?: boolean
}

export type AreaSPLineData = [BasicSeriesData, BasicSeriesData]

export const DUAL_GRAPH_DATA_INDEX = {
  FIRST: 0,
  SECOND: 1,
} as const

export type AreaSPLineProps = {
  data: AreaSPLineData
  chartCSS?: CSS
  options?: Options
}

export interface TrendsTooltipProps {
  value: Point
  title: string
  percentInTitle: boolean
}
